import { render, staticRenderFns } from "./index.vue?vue&type=template&id=93744fbe&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=93744fbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93744fbe",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductsHowTo: require('/home/ubuntu/nuxt/bonkers/releases/20230530095517/components/products/how-to.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230530095517/components/site/feefo.vue').default})
